<template>
  <div class="pay-account-item invoice-select-item" :class="{'selected': selected}" @click="selectItem">
    <div class="info-box">
      <p class="info-item">
        <label class="info-title">公司名称:</label>
        <span class="info-text" :title="data.companyName">{{data.companyName}}</span>
      </p>
      <p class="info-item">
        <label class="info-title">付款账号:</label>
        <span class="info-text" v-if="!isShowEdit">{{data.bankAccount}}</span>
        <el-input v-else size="small" v-model="val" @change="validateBankAccount"></el-input>
        <p class="error-desc" v-show="errorDesc">{{ errorDesc }}</p>
      </p>
    </div>
    <div class="action-box">
      <span v-show="!isShowEdit">
        <i class="el-icon-edit" @click.stop="edit"></i>
        <i class="el-icon-delete" @click.stop="deleteBank"></i>
      </span>
      <span v-show="isShowEdit">
        <i class="el-icon-close" @click.stop="edit"></i>
        <i class="el-icon-check" @click.stop="save"></i>
      </span>
    </div>
  </div>
</template>
<script>
  import {saveBankAccount, deleteBank} from '../utils/api.js';
  export default {
    name: 'pay-account-item',
    props: {
      data: Object,
      selected: Boolean,
      index: Number
    },
    computed: {
      isShowEdit() {
        return this.isEditing || !this.data.id;
      }
    },
    data() {
      return {
        isEditing: false,
        val: this.data.bankAccount,
        errorDesc: ''
      }
    },
    methods: {
      validateBankAccount(val) {
        console.log(val);
        if (!val || !val.trim()) {
          this.errorDesc = '请输入正确的付款账号';
        } else if (!/^[0-9a-zA-Z]+$/ig.test(val)) {
          this.errorDesc = '付款账号只能是数字和字母';
        } else {
          this.errorDesc = '';
        }
        return !!this.errorDesc;
      },
      edit() {
        this.isEditing = !this.isEditing;
        if (!this.data.id) {
          this.$emit('delete', this.index);
        }
      },
      deleteBank() {
        this.$confirm('确定要删除此信息吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let result = await deleteBank({bankInfoId: this.data.id});
          if (result && result.success) {
            this.$message.success('操作成功');
            this.$emit('delete', this.index);
          }
        }).catch(() => {});
      },
      async save() {
        if (!this.val || !this.val.trim() || this.validateBankAccount(this.val)) return;
        let params = {
          bankAccount: this.val.trim(),
          companyName: this.data.companyName
        }
        if (this.data.id) {
          params.bankInfoId = this.data.id;
        }
        let result = await saveBankAccount(params);
        if (result && result.success) {
          this.$message.success('操作成功');
          this.isEditing = !this.isEditing;
          let id = this.data.id || result.result.id;
          this.$emit('save', this.index, Object.assign(this.data, {id, bankAccount: this.val.trim()}));
        }
      },
      selectItem() {
        this.$emit('select', this.data);
      }
    }
  }
</script>
<style lang="scss">
  .pay-account-item {
    width: 250px;
    .info-box {
      .info-item {
        height: 36px;
        line-height: 36px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        .info-title {
          color: #666;
        }
        .el-input {
          display: inline-block;
          width: 160px;
          input::-webkit-inner-spin-button {
            display: none;
          }
        }
      }
    }
    .action-box {
      margin-top: 10px;
      padding-top: 10px;
      border-top: 1px dashed #ddd;
      text-align: right;
      i {
        display: inline-block;
        margin-left: 10px;
        font-size: 16px;
      }
    }
    .error-desc {
      color: red;
      font-size: 12px;
    }
  }
</style>